
import { Component, Prop, Vue } from "vue-property-decorator";
import SpecialOpenDaysCard from "./SpecialOpenDateCard.vue";
import SpecialOpenDayDialog from "@/components/restaurant/specialOpenDays/SpecialOpenDateDialog.vue";
import Restaurant from "@/domain/restaurant/Restaurant";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import RemoteServices from "@/services/RemoteServices";
import UtilService from "@/services/UtilService";
@Component({
  components: { ConfirmationDialog, SpecialOpenDayDialog, SpecialOpenDaysCard }
})
export default class SpecialOpenDaysList extends Vue {
  created() {
    this.restaurant.specialOpenDays.sort(UtilService.stringComparatorAscending);
  }

  @Prop()
  restaurant!: Restaurant;

  showEditSpecialOpenDayDialog = false;

  get confirmationDialog() {
    return this.$refs.ConfirmationDialog as ConfirmationDialog;
  }

  get dates() {
    return this.restaurant.specialOpenDays;
  }

  addNewDate(newDate: string) {
    this.restaurant.specialOpenDays.push(newDate);
    this.restaurant.specialOpenDays.sort(UtilService.stringComparatorAscending);
  }

  removeDate(date: string) {
    this.restaurant.specialOpenDays = this.restaurant.specialOpenDays.filter(
      d => d !== date
    );
    this.restaurant.specialOpenDays.sort(UtilService.stringComparatorAscending);
  }

  async removeOpenDate(date: string) {
    if (
      await this.confirmationDialog.open(
        this.$tc("restaurant.specialOpenDates.delete.message"),
        this.$t("delete.confirmation") +
          "\n" +
          date +
          "\n" +
          this.$t("delete.warning")
      )
    ) {
      try {
        await RemoteServices.removeSpecialOpenDate(
          date,
          this.restaurant.restaurantId
        );
        await this.$store.dispatch(
          "success",
          this.$t("restaurant.specialOpenDates.delete.success")
        );
        this.removeDate(date);
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
    }
  }
}
